<template>
  <div class="LandscapeNavMobile">
    <ul class="LandscapeNavMobileList">
      <nav-link-mobile to="info" label="Home" icon="home" />
      <nav-link-mobile
        v-if="isStartup"
        to="premises"
        label="Premises"
        icon="receipt"
        match-children-routes
      />
      <nav-link-mobile
        v-if="allowedToFeeds"
        to="feeds"
        label="Feeds"
        icon="rss_feed"
        match-children-routes
      />
      <nav-link-mobile to="topics" label="Topics" icon="forum" />
      <nav-link-mobile
        v-if="!isStartup"
        to="insights"
        label="Insights"
        icon="insight"
        svg
        match-children-routes
      />
      <nav-link-mobile
        v-if="allowedToOutputs"
        to="activity-analysis"
        label="Analytics"
        icon="trending_up"
        match-children-routes
      />
    </ul>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import NavLinkMobile from './NavLinkMobile'

export default {
  name: 'LandscapeNavMobile',
  components: {
    NavLinkMobile
  },
  computed: {
    ...mapGetters(['allowedToOutputs', 'allowedToFeeds', 'isStartup'])
  }
}
</script>

<style>
.LandscapeNavMobile {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: theme('zIndex.navMobile');
  background: theme('colors.gray.100');
  border-top: 1px solid theme('colors.gray.300');
}
.LandscapeNavMobileList {
  display: flex;
  justify-content: space-around;
  align-items: center;
  max-width: 600px;
  height: theme('height.nav-mobile');
  margin: 0 auto;
  padding: 0;
}
</style>
